import styled from 'styled-components'

export const SlideImgWrapper = styled.picture<{
  $hasContent: boolean
  $isMobile: boolean
  $version: number
}>`
  ${({ $isMobile, $hasContent, $version }) =>
    $isMobile
      ? `
      display: ${$isMobile ? 'grid' : 'flex'};
      align-items: ${$isMobile && $hasContent ? 'end' : 'center'};
      align-content: normal;
      ${$isMobile && $hasContent && 'padding-bottom: 3.5rem'};
    `
      : `
        align-content: ${$version === 0 ? 'end' : 'center'};
        display: ${$version === 0 ? 'flex' : 'grid'};
        ${$version !== 0 && 'align-items: stretch; justify-content: space-around'};
      `}
`

interface StyledImageProps {
  fetchpriority?: 'high' | 'low' | 'auto'
  $hasContent: boolean
  $isImageMobile: boolean
  $isMobile: boolean
  $version: number
}

export const SlideImg = styled.img<StyledImageProps>`
  max-width: 100%;
  width: ${({ $version, $isMobile }) => ($version === 0 ? '100%' : $isMobile ? '100%' : '100vw')};
  object-fit: cover;
  object-position: center;
  z-index: 8;
  opacity: 1;
  transition: opacity ease-in-out 200ms;

  image-rendering: -webkit-optimize-contrast;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;

  ${({ $version, $isMobile, $isImageMobile, $hasContent }) =>
    $version === 0
      ? `
        ${
          $isMobile
            ? `
            object-fit: ${$isImageMobile ? 'cover' : 'contain'};
            aspect-ratio: ${$isImageMobile ? '3 / 4' : '16 / 9'};
            object-position: ${$hasContent ? 'center bottom' : 'center'};
            height: auto;
            `
            : `
            aspect-ratio: 16 / 9;
            height: 100%;
            `
        }
        `
      : `
      ${
        $isMobile
          ? `
            object-fit: contain;
            aspect-ratio: 16 / 9;
            object-position: ${$hasContent ? 'center bottom' : 'center'};
            height: auto;`
          : `
          object-fit: contain;
          aspect-ratio: 9 / 5;
          `
      }
    `}
`

export const SlideVideo = styled.video`
  width: 100%;
  object-fit: cover;
  object-position: center;
`
